import React, { useRef, useCallback, useEffect } from "react";
import styled from "styled-components";
import Close from "../images/Path.png";
import styles from "./modal.scss";
import ProductSlider from "../productSlider/productSlider";
import Portal from "@tw/shared-ui-components/lib/components/portal/portal";

const Background = styled.div`
  width: 100%;
  height: 100%;
  background: rgba(44, 44, 44, 0.7);
  backdrop-filter: blur(10px);
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 111;
  @media screen and (max-width: 425px) {
    background: rgba(44, 44, 44, 1);
    height: 100vh;
    //margin-top: -110px;
    top: 0;
  }

  @media screen and (min-width: 765px) {
    //margin-top: -138px;
    top: 0;
  }
  @media screen and (min-width: 1200px) {
    // margin-left: -54px;
    // margin-top: -25px;
    // top: 25px;
    top: 0;
    left: 0;
    z-index: 9999;
    position: fixed;
    margin-top: 0px;
  }
`;

const ModalWrapper = styled.div`
  width: 351px;
  height: 351px;
  box-shadow: 0 5px 16px rgba(0, 0, 0, 0.2);
  background: #fff;
  color: #000;
  position: relative;

  z-index: 99999999999;
  display: flex;
  flex-direction: column;
  justify-content: center;

  overflow: hidden;
  //padding: 2.5px 22.5px;

  @media screen and (min-width: 993px) {
    width: 562px;
    height: 562px;
    z-index: 99999999999;
    border-radius: 20px;
  }
`;

export const Modal = (props) => {
  const { showModal, setShowModal, gallery, currentIndex, setCurrentIndex } =
    props;

  const modalRef = useRef();

  const closeModal = (e) => {
    if (modalRef.current === e.target) {
      setShowModal(false);
    }
  };
  const keyPress = useCallback(
    (e) => {
      if (e.key === "Escape" && showModal) {
        setShowModal(false);
      }
    },
    [setShowModal, showModal]
  );
  const bodyEl =
    typeof window !== "undefined" && document.querySelector("body");

  useEffect(() => {
    showModal
      ? (bodyEl.style.overflow = "hidden")
      : (bodyEl.style.overflow = "unset");
  }, [showModal]);

  useEffect(() => {
    document.addEventListener("keydown", keyPress);
    return () => document.removeEventListener("keydown", keyPress);
  }, [keyPress]);

  return (
    <Portal>
      {showModal ? (
        <Background onClick={closeModal} ref={modalRef}>
          <ModalWrapper showModal={showModal}>
            <div className="Wrapper">
              <ProductSlider
                gallery={gallery}
                showArrows
                currentIndex={currentIndex}
                setCurrentIndex={(i) => setCurrentIndex(i)}
                name="-modal"
              />
            </div>
            <img
              src={Close}
              alt="close button"
              className={styles["close"]}
              onClick={() => setShowModal((prev) => !prev)}
            />
          </ModalWrapper>
        </Background>
      ) : null}
    </Portal>
  );
};
